export default __webpack_public_path__ + "static/media/WAS0333.34I-41678_-24953_0.deae1839.jpg";